import { ADD_BACKGROUND, REMOVE_BACKGROUND } from '../actions'

const initialState = {
  backgrounds: [{ type: 'default' }]
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_BACKGROUND:
      return {
        ...state,
        backgrounds: state.backgrounds.concat({ ...action.payload })
      }
    case REMOVE_BACKGROUND:
      return {
        ...state,
        backgrounds: state.backgrounds.filter((val, index) => index > 0) // remove first element
      }
    default:
      return state
  }
}

export const setBackground = background => (dispatch, getState) => {
  // Don't add the same background twice
  const currentBgs = getState().background.backgrounds
  const currentBg = currentBgs[currentBgs.length - 1]

  if (JSON.stringify(currentBg) === JSON.stringify(background)) {
    return
  }

  dispatch({
    type: ADD_BACKGROUND,
    payload: background
  })

  // wait for transition then remove
  setTimeout(() => dispatch({ type: REMOVE_BACKGROUND }), 1000)
}



// WEBPACK FOOTER //
// ./src/redux/modules/background.js